(function($) {

  'use strict';

  var MODULE_SELECTOR = '.dw_pb_marketing_insights_listing';

  $(MODULE_SELECTOR).find('.wp-pagenavi a').on('click', function(e) {
    window.location.href = $(this).attr('href');
    return false;
  });

  $(window).load(function() {
    if ($(MODULE_SELECTOR).length && window.location.href.indexOf('?et_blog') !== -1) {
      var loggedInOffset = parseInt($('html').css('margin-top'), 10);
      var mastheadHeight = $('.et-l--header').height();
      var nextElementOffset = $(MODULE_SELECTOR).closest('.et_pb_section').offset().top;

      $('html, body').animate({
        scrollTop: nextElementOffset - mastheadHeight - loggedInOffset
      }, 1000);
    }
  });

})(jQuery);
